import {
  CardMedia,
  Container,
  Section,
  SectionHeaderContent
} from '@/ui/components'
import { getTitleTag } from '@/utils'
import { memo } from 'react'
import { SectionPartnersProps } from './type'

const SectionPartners = ({
  title,
  titleLayout,
  items,
  section
}: SectionPartnersProps) => {
  if (!items) {
    return null
  }

  return (
    <Section data={section} className="s-section-partners pt-0">
      <SectionHeaderContent as={getTitleTag(titleLayout)}>
        {title}
      </SectionHeaderContent>
      <Container className={''} anim="fade-in">
        <div
          className={
            'gap-xs grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5'
          }
        >
          {!!items?.length &&
            items?.map((item) => <CardMedia key={item?.id} {...item} />)}
        </div>
      </Container>
    </Section>
  )
}

SectionPartners.displayName = 'SectionPartners'

export default memo(SectionPartners)
